// extracted by mini-css-extract-plugin
export var blue = "_35-f";
export var brand = "_35-b";
export var darkGrey = "_35-e";
export var disabled = "_35-4";
export var disabledSubtle = "_35-5";
export var error = "_35-6";
export var green = "_35-g";
export var grey = "_35-d";
export var icon = "_35-0";
export var inherit = "_35-a";
export var lightGrey = "_35-c";
export var orange = "_35-i";
export var pink = "_35-k";
export var primary = "_35-1";
export var purple = "_35-l";
export var red = "_35-j";
export var secondary = "_35-2";
export var success = "_35-9";
export var tertiary = "_35-3";
export var warning = "_35-7";
export var warningSecondary = "_35-8";
export var white = "_35-m";
export var yellow = "_35-h";